{
  "brand": "Aruba Animal Radar",
  "tagline": "Expedientes de animales callejeros — avistamientos, mascotas perdidas, chips.",
  "nav": {
    "map": "Mapa",
    "addSighting": "Añadir avistamiento",
    "reportLost": "Reportar perdido",
    "searchChip": "Buscar chip",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión"
  },
  "panel": {
    "title": "Casos activos",
    "lostTitle": "Actualmente perdidos",
    "emptyLost": "No hay reportes de perdidos activos.",
    "openPanel": "Expedientes",
    "closePanel": "Cerrar",
    "sightings": "Avistamientos",
    "related": "Avistamientos vinculados",
    "stepPrev": "Avistamiento anterior",
    "stepNext": "Siguiente avistamiento"
  },
  "fields": {
    "type": "Tipo",
    "breed": "Raza",
    "color1": "Color primario",
    "color2": "Color secundario",
    "color3": "Tercer color",
    "chip": "Microchip",
    "spayed": "Esterilizado / Castrado",
    "ownership": "Estado de propiedad",
    "ifFound": "Si lo encuentra, contacte",
    "notes": "Notas",
    "location": "Ubicación",
    "sightedAt": "Visto el",
    "contact": "Información de contacto",
    "unknown": "Desconocido",
    "none": "Ninguno",
    "other": "Otro"
  },
  "types": {
    "dog": "Perro",
    "cat": "Gato",
    "other": "Otro"
  },
  "colors": {
    "black": "Negro",
    "white": "Blanco",
    "brown_chocolate": "Marrón / Chocolate",
    "tan_fawn": "Canela / Ante",
    "red_orange": "Rojo / Naranja",
    "gray_blue": "Gris / Azul",
    "cream_yellow": "Crema / Amarillo",
    "gold_apricot": "Dorado / Albaricoque"
  },
  "ownership": {
    "confirmed_owned": "Propiedad confirmada",
    "confirmed_abandoned": "Abandonado confirmado",
    "no_known_owner": "Sin dueño conocido",
    "reported_lost": "Reportado como perdido"
  },
  "spayed": {
    "yes": "Sí",
    "no": "No",
    "unknown": "Desconocido"
  },
  "actions": {
    "submit": "Enviar",
    "cancel": "Cancelar",
    "search": "Buscar",
    "link": "Vincular avistamientos",
    "unlink": "Desvincular del animal",
    "save": "Guardar",
    "pickOnMap": "Elegir en el mapa"
  },
  "forms": {
    "addSightingTitle": "Registrar avistamiento",
    "reportLostTitle": "Reportar mascota perdida",
    "chipSearchTitle": "Búsqueda por chip",
    "chipPlaceholder": "Ingrese número de microchip",
    "breedOtherHint": "Se pueden añadir razas personalizadas al reportar una mascota perdida.",
    "noResults": "No se encontraron coincidencias."
  },
  "lang": {
    "label": "Idioma",
    "en": "English",
    "es": "Español",
    "pap": "Papiamento",
    "nl": "Nederlands"
  },
  "status": {
    "loading": "Cargando…",
    "mapLoading": "Inicializando mapa…",
    "error": "Algo salió mal."
  }
}
